import { create } from 'zustand'
import { FilterState, AchievementType } from '@/types'

interface FilterStore extends FilterState {
  selectedGeneration: string | null
  setSelectedCategory: (category: string | null) => void
  setStartYear: (year: number | null) => void
  setEndYear: (year: number | null) => void
  setSelectedPrefectures: (prefectures: number[]) => void
  setSelectedTeams: (teams: number[]) => void
  setSelectedGeneration: (generation: string | null) => void
  setAchievementType: (type: AchievementType) => void
  resetFilters: () => void
}

const useFilterStore = create<FilterStore>((set) => ({
  // 初期状態
  selectedCategory: null,
  startYear: null,
  endYear: null,
  selectedPrefectures: [],
  selectedTeams: [],
  selectedGeneration: null,
  achievementType: AchievementType.CHAMPIONSHIP,

  // アクション
  setSelectedCategory: (category) => {
    console.log('Setting selectedCategory:', category)
    set({ selectedCategory: category })
  },
  setStartYear: (year) => {
    console.log('Setting startYear:', year)
    set({ startYear: year })
  },
  setEndYear: (year) => {
    console.log('Setting endYear:', year)
    set({ endYear: year })
  },
  setSelectedPrefectures: (prefectures) => {
    console.log('Setting selectedPrefectures:', prefectures)
    set({ selectedPrefectures: prefectures })
  },
  setSelectedTeams: (teams) => {
    console.log('Setting selectedTeams:', teams)
    set({ selectedTeams: teams })
  },
  setSelectedGeneration: (generation) => {
    console.log('Setting selectedGeneration:', generation)
    set({ selectedGeneration: generation })
  },
  setAchievementType: (type) => {
    console.log('Setting achievementType:', type)
    set({ achievementType: type })
  },
  resetFilters: () => {
    console.log('Resetting filters')
    set({
      selectedCategory: null,
      startYear: null,
      endYear: null,
      selectedPrefectures: [],
      selectedTeams: [],
      selectedGeneration: null,
      achievementType: AchievementType.CHAMPIONSHIP
    })
  }
}))

export default useFilterStore
